import numeral from 'numeral';

const globalUtils = {
    /**
     * Chuyển sang hiển thị kiểu giá tiền
     * @param {number} value: Giá trị cần hiển thị
     * @returns => Chuỗi hiển thị giá tiền
     */
    formatNumberToPrice(value) {
        return numeral(value).format('0,0');
    },

    /**
     * Hiển thị kiểu 0001
     * @param {number} value : giá trị
     * @param {number} num : số kí tự cần hiển thị đằng trước
     * @param {string} char : kí hiệu hiển thị đằng trước
     * @returns
     */
    padStart(value, num, char) {
        if (!value || !num || !char) return value;
        return String(value).padStart(num, char);
    },
    copyClipboard: (copyValue) => {
        navigator.clipboard.writeText(copyValue);
    },
    randomString(length) {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(
                Math.floor(Math.random() * charactersLength)
            );
        }
        return result;
    },
    validateEmail(email) {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    },
};
export default globalUtils;
